import React from 'react'
import BookNow from '../Bookings/BookNow'

const ReferralBooking = () => <BookNow title='Referral Book Service' />

export default ReferralBooking